import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cluster_spaces",
  "use": "cluster_spaces-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"cluster_spaces\"><path d=\"M12 4v6h6V4zm4.5 4.5h-3v-3h3zM4 18h6v-6H4zm1.5-4.5h3v3h-3zM4 10h6V4H4zm8 8h6v-6h-6zm1.5-4.5h3v3h-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol